module.exports = __webpack_public_path__ + "img/组 3.edc2ce93.webp";